import { numberFormatter, numberFormatterCount, valueFormatter } from '../../utils/utilities';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfinity } from '@fortawesome/free-solid-svg-icons';

export enum VALUE_TYPE {
  COUNT = 'count',
  AMOUNT = 'amount',
}

interface INumberFormatterHelperProps {
  initialNumber: number;
  type: VALUE_TYPE;
  shorterNumberFormat?: boolean;
  isInfinity?: boolean;
}
export const getFormattedNumberValue = ({
  initialNumber,
  type,
  shorterNumberFormat,
  isInfinity,
}: INumberFormatterHelperProps): number | string | JSX.Element => {

  let localValue: number | string | JSX.Element = '';
  const getFormattedValue = (value: number): string => {
    switch (type) {
      case 'amount':
        return shorterNumberFormat ? valueFormatter(value) : numberFormatter(value);
      case 'count':
        return shorterNumberFormat ? valueFormatter(value) : numberFormatterCount(value);
    }
  };

  if (initialNumber > 999) {
    localValue = getFormattedValue(initialNumber);
  } else if (initialNumber === null && isInfinity) {
    localValue = <FontAwesomeIcon icon={faInfinity} width={12}/>;
  } else if (!initialNumber) {
    localValue = 0;
  } else {
    localValue = initialNumber;
  }

  return localValue;
};